import script from "./tooltipBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./tooltipBtn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__